<div
  class="drop"
  [ngClass]="{
    'drop--dropped': dropped,
    'drop--small': isSmall,
    'drop--hover': isHovered
  }"
>
  <div class="drop_action">Drop</div>
  <div class="drop_action-type">{{ actionType }}</div>
</div>
